import React from 'react';

import { ApplicationSyncContext } from './useApplicationSyncContext';

export default function ApplicationSyncContextProvider({ children }: { children: React.ReactNode }) {
  const [isSynced, setIsSynced] = React.useState(false);

  const value = React.useMemo(() => ({
    isSynced,
    setIsSynced,
  }), [isSynced]);

  return (
    <ApplicationSyncContext.Provider value={value}>
      {children}
    </ApplicationSyncContext.Provider>
  );
}
